import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';

import BannerLayout from '../../layouts/banner';

import Image from '../../../../../containers/assets/supply-chain-decisions.png'

class SupplyChainDecisions extends PureComponent {
  render() {
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="What to expect next"
        subSection="Supply Chain decisions"
        alertText="New Supply Chain Decisions"
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p><strong>Distribution Center Options</strong></p>
            <p>Teams will have the option to open up a distribution center to potentially reduce the time it takes for inventory to be delivered to customers. However, it’ll be at a cost(tradeoff: time vs. cost).</p>
            <p><strong>New Machine Options</strong></p>
            <p>Teams will have the option to buy new machines that are far more productive and cost a lot more (tradeoff: revenues vs. costs).</p>
          </Fragment>
        )}
        visual={(
          <img src={Image} alt="Chain Decisions" />
        )
        }
        visualProps={{
          noBorder: true,
          noBackground: true
        }}
      />
    );
  }
}

export default SupplyChainDecisions;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/supply-chain-decisions.js